const exploreCategories = [
    "Bartivities", 
    "Small Concert Venues", 
    "Outdoor Arts & Concert Venues", 
    "Local Festivals & Events"
]

export default exploreCategories;